import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import uniqueId from 'lodash/uniqueId';

import ErrorLabel from '../components/ErrorLabel';
import Input from '../../../../components/Input';
import Label from '../../../../components/Label';
import messages from './messages';
import basicInfoMessages from '../messages';

import '../styles.css';

const AgeData = ({ onChange, initialValue }) => {
  const id = uniqueId('age-data');
  return (
    <div styleName="field">
      <Label styleName="menu-field-label" as="label" htmlFor={id}>
        <FormattedMessage {...messages.ageData} />
      </Label>
      <Input
        fluid
        type="number"
        min="0"
        id={id}
        value={initialValue.value}
        onChange={(e, { value }) => {
          onChange(e, { value: Number(value) });
        }}
      />
      {initialValue.showError && <ErrorLabel error={{ ...basicInfoMessages.invalidError }} />}
    </div>
  );
};

AgeData.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default AgeData;
